import React from "react";
import { connect } from "react-redux";
import Loader from "react-loader-spinner";
import colors from "../../../styles/_colors.scss";
import itemSizes from "constants/sizes.scss";

function MainLoader({ loadingStatus }) {
  console.log("colors.off_white in location: ", colors.off_white);
  return (
    <>
      {loadingStatus === "pending" && (
        <div className="main-loader-container">
          <div className="main-loader-backdrop" />
          <div className="main-loader-inner-wrapper">
            <Loader
              type="Oval"
              color={colors.off_white}
              height={Number.parseInt(itemSizes.navigation_height)}
              width={Number.parseInt(itemSizes.navigation_height)}
            />
          </div>
        </div>
      )}
    </>
  );
}

function mapStateToProps(state) {
  return {
    loadingStatus: state.itemLists.status,
  };
}

export default connect(mapStateToProps)(MainLoader);
